module.exports = __webpack_public_path__ + "static/mycelium-71cf6c5ce3d91514adb346357d7f0532.jpg";